import { css } from '@emotion/react';
import styled, { Interpolation } from '@emotion/styled';
import { pxToRem, Text, Theme } from '@lbcamden/lib-react';

export const selectStyles: Interpolation<Theme> = (theme) => css`
  border: 1px solid ${theme.colors.muted};
`;

export const DropdownsContainer = styled.div`
  display: flex;
  gap: ${({ theme }) => theme.spacing(2)};

  .contactMethod {
    flex: 1;
  }

  .inOrOut {
    min-width: ${pxToRem(115)};
  }
`;

export const EventsContainer = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing(4)};
  width: 100%;
  margin-top: ${({ theme }) => theme.spacing(8)};

  h5 {
    margin-bottom: ${({ theme }) => theme.spacing(1)};
  }
`;

export const EventInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing(1)};

  span {
    ${({ theme }) => theme.text.body2};
    color: ${({ theme }) => theme.colors.textSecondary};
  }
`;

export const CaseDetails = styled(Text)`
  white-space: pre-wrap;
`;
